import { graphql } from "gql.tada";

export const LinkFragment = graphql(`
  fragment LinkFragment on Link {
    text
    isExternal
    url
    pageReference: reference {
      __typename
      ... on ArticlePage {
        slug
      }
      ... on ContentHubPage {
        slug
      }
      ... on ConversionPage {
        slug
      }
      ... on CreativeSpecsPage {
        slug
      }
      ... on EditorialPage {
        slug
      }
      ... on FaqPage {
        slug
      }
      ... on Homepage {
        slug
      }
      ... on ProductPage {
        slug
      }
      ... on TermsPage {
        slug
      }
    }
  }
`);
